import { bool, string, object, oneOf } from "prop-types";
import { useTranslation } from "react-i18next";
import { BreakdownTableDepths } from "@repo/utils";
import { AddButtonFull } from "@components";
import classnames from "classnames";

export const AddChildTask = ({
  parent,
  tableDepth,
  style,
  className,
  showId,
}) => {
  const { t } = useTranslation();

  const addModule = () => {
    parent.addChild(true, !parent.hasChildren);
  };

  return (
    <>
      <AddButtonFull
        id={showId ? "addModuleFirst" : undefined}
        onClick={addModule}
        name={`Add new ${t(
          `proposal_parts.module_levels.level_${tableDepth}`
        )} `}
        style={style}
        className={classnames(className, `addElement-${tableDepth}`)}
      >
        {t("common.add")}{" "}
        {t(`proposal_parts.module_levels.level_${tableDepth}`)}
      </AddButtonFull>
    </>
  );
};

AddChildTask.propTypes = {
  parent: object,
  tableDepth: oneOf([
    BreakdownTableDepths.MODULE,
    BreakdownTableDepths.FEATURE,
    BreakdownTableDepths.TASK
  ]).isRequired,
  style: object,
  className: string,
  showId: bool,
};
